import type { HTMLAttributes } from 'react';
import { cx } from '../internal/cx';
import styles from './Divider.module.css';

export interface DividerProps extends HTMLAttributes<HTMLElement> {
  orientation?: 'horizontal' | 'vertical';
  /** Decorative dividers are hidden from assistive technology. Default true. */
  decorative?: boolean;
}

export function Divider({
  orientation = 'horizontal',
  decorative = true,
  className,
  ...rest
}: DividerProps) {
  if (orientation === 'horizontal') {
    return (
      <hr
        className={cx(styles.horizontal, className)}
        aria-hidden={decorative || undefined}
        {...rest}
      />
    );
  }
  return (
    <span
      className={cx(styles.vertical, className)}
      {...(decorative
        ? { 'aria-hidden': true }
        : { role: 'separator', 'aria-orientation': 'vertical' as const })}
      {...rest}
    />
  );
}

export interface KbdProps extends HTMLAttributes<HTMLElement> {
  /** Accessible expansion, e.g. "Control" for "Ctrl". */
  title?: string;
}

export function Kbd({ className, ...rest }: KbdProps) {
  return <kbd className={cx(styles.kbd, className)} {...rest} />;
}
